var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2D338A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.544 6h7.098l3.643 6l-3.643 6h-7.16l3.58-6zm3.768 2.143L14.636 12l-2.324 3.857h2.082L16.704 12l-2.325-3.857h-2.074z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3 8.687L7.288 12l1.998 3.287L8.01 17.42L4.714 12l3.323-5.473z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.a22d9536b030a3252639e84e3057f5f4.svg";
export { ForwardRef as ReactComponent };